import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Title, Text, Box, ScrollArea, Stack } from "@mantine/core";
import FacultieAccordion from "../components/Overview/FacultieAccordion";
import { getFacultadesResume } from "../actions/overviewActions";
import useActiveProcess from '../hooks/useActiveProcess'

const OverviewPage = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { data: dataFaculties, loading: loadingFaculties} = useSelector((state) => state.overview.resumeFaculty);
  
  const activeProcess = useActiveProcess();
  const faculties = useMemo(() => dataFaculties, [dataFaculties]);
  
  useEffect(() => {
    dispatch(getFacultadesResume(activeProcess.Id,user));
  }, []);

  return (
    <div>
      <section className="bienvenida">
        <div style={{ marginBottom: "1rem" }}>
          <Title fw={400}>Visión General de Evaluaciones</Title>
        </div>
        <div className="bienvenida-content">
          <Text size="md">
            Esta sección presenta un resumen consolidado del proceso de evaluación institucional realizado en el marco del Plan Estratégico Institucional (PEI). Se visualizan las evidencias cargadas por cada dirección de carrera, así como las fortalezas y debilidades identificadas en relación con los 12 criterios de calidad definidos. Además, se accede a los planes de mejora realizados por cada unidad de gestión, lo que permite monitorear el estado actual y orientar acciones de mejora continua a partir del análisis de sus resultados.
          </Text>
        </div>
      </section>
      <section>
        <div className="card-base">
          <Box h="100%" >
            <ScrollArea.Autosize mah={'55vh'} mx="auto" type="always" offsetScrollbars>
              <Stack>
                <FacultieAccordion faculties={faculties} loading={loadingFaculties} />
              </Stack>
            </ScrollArea.Autosize>
          </Box>
        </div>
      </section>
    </div>
  );
};

export default OverviewPage;